export type ReliefBoardPrintFilters = {
  tab?: 'all' | 'nr';
  rankId?: string;
  search?: string;
};

export function reliefBoardPrintPath(filters: ReliefBoardPrintFilters = {}): string {
  const qs = new URLSearchParams();
  if (filters.rankId?.trim()) qs.set('rankId', filters.rankId.trim());
  if (filters.tab === 'nr') qs.set('tab', 'nr');
  if (filters.search?.trim()) qs.set('q', filters.search.trim());
  const q = qs.toString();
  return q ? `/crew/relief-board/print?${q}` : '/crew/relief-board/print';
}

export function reliefBoardListApiUrl(params: URLSearchParams): string {
  const qs = new URLSearchParams();
  const rankId = params.get('rankId')?.trim();
  if (rankId) qs.set('rankId', rankId);
  const s = qs.toString();
  return `/crew/reports/relief-board${s ? `?${s}` : ''}`;
}

export function reliefBoardBackPath(): string {
  return '/crew/relief-board';
}
